import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { subscribeNewsletter } from '../lib/api';

function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [consent, setConsent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    setSubmitting(true);
    try {
      await subscribeNewsletter({ email, consent });
      toast.success('¡Gracias! Revisa tu correo para confirmar la suscripción.');
      setEmail('');
      setConsent(false);
    } catch (error) {
      toast.error(error.errors ? error.errors.join(' ') : 'No hemos podido completar la suscripción. Inténtalo de nuevo.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <form className="newsletter-form" onSubmit={handleSubmit}>
      <h3>Carta para lectores viajeros</h3>
      <p>Recomendaciones, viajes literarios y novedades del podcast, directo a tu correo.</p>
      <div className="newsletter-form__row">
        <input
          type="email"
          required
          placeholder="tu@email.com"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
        <button type="submit" disabled={submitting}>
          {submitting ? 'Enviando…' : 'Suscribirme'}
        </button>
      </div>
      <label className="newsletter-form__consent">
        <input
          type="checkbox"
          required
          checked={consent}
          onChange={(event) => setConsent(event.target.checked)}
        />
        Acepto la <a href="/privacidad">política de privacidad</a>.
      </label>
    </form>
  );
}

export default NewsletterForm;
